import React from 'react';
import styles from './TextEffectsSticker.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';

export type TextEffectsStickerProps = TextEffectsSharedProps;

const TextEffectsSticker: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared {...props}>
      <div
        className={styles.wrapper}
        data-testid={TestIds.viewer.container}
        data-text={text}
      >
        <div className={styles.text} data-testid={TestIds.viewer.text}>
          {text}
        </div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsSticker;
